export class SkipToMainContent {
  skipToMainContentLink: HTMLLinkElement;

  constructor(skipToMainContentLink: HTMLLinkElement) {
    this.skipToMainContentLink = skipToMainContentLink;
  }

  interceptLinkClick = (event: MouseEvent) => {
    event.preventDefault();
    const mainContent = document.querySelector(
      new URL(this.skipToMainContentLink.href).hash
    ) as HTMLElement;

    mainContent.tabIndex = -1;
    mainContent.focus();
  };

  addEventListeners = () => {
    this.skipToMainContentLink.addEventListener(
      "click",
      this.interceptLinkClick
    );
  };

  removeEventListeners = () => {
    this.skipToMainContentLink.removeEventListener(
      "click",
      this.interceptLinkClick
    );
  };
}
